<template>
   <div>
      <navbar-component />
      <main class="profile-page">
         <section class="relative block h-500-px">
            <div
               class="absolute top-0 w-full h-full bg-center bg-cover"
               style="
                  background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
               "
            >
               <span
                  id="blackOverlay"
                  class="w-full h-full absolute opacity-50 bg-black"
               ></span>
            </div>
            <div
               class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
               style="transform: translateZ(0)"
            >
               <svg
                  class="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
               >
                  <polygon
                     class="text-blueGray-200 fill-current"
                     points="2560 0 2560 100 0 100"
                  ></polygon>
               </svg>
            </div>
         </section>
         <section class="relative py-16 bg-blueGray-200">
            <div class="container mx-auto px-4">
               <div
                  class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64"
               >
                  <div class="px-6 py-10">
                     <div class="text-center mb-8">
                        <h2 class="text-4xl font-bold text-blueGray-700 mb-2">
                           DV Command Suite of Products
                        </h2>
                        <div class="flex justify-center mb-4">
                           <span
                              class="inline-block w-24 h-1 rounded bg-emerald-400"
                           ></span>
                        </div>
                        <p class="text-lg text-blueGray-600 mb-8">
                           Explore our suite of advanced control products for
                           the hydraulic fracturing industry.
                        </p>
                     </div>
                     <div
                        class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto"
                     >
                        <div
                           class="rounded-xl shadow-lg bg-gradient-to-br from-blue-50 to-blue-200 p-8 m-4 flex flex-col items-center hover:shadow-2xl transition-shadow"
                        >
                           <img
                              src="@/assets/img/dataPipes.jpg"
                              alt="DVCommand"
                              class="w-24 h-24 object-contain mb-4 rounded-lg shadow-md bg-white"
                           />
                           <h3
                              class="text-2xl font-semibold text-blue-800 mb-2 flex items-center"
                           >
                              <i class="fas fa-truck mr-2 text-blue-500"></i
                              >DVCommand
                           </h3>
                           <p class="text-blueGray-700 text-center">
                              The industry standard for frac data acquisition,
                              control, and reporting. Integrates seamlessly with
                              our
                              <a
                                 href="/wavedata"
                                 class="text-blue-500 underline hover:text-blue-700"
                                 >WaveData Cloud solution</a
                              >
                              and third-party equipment.
                           </p>
                        </div>
                        <div
                           class="rounded-xl shadow-lg bg-gradient-to-br from-emerald-50 to-emerald-200 p-8 m-4 flex flex-col items-center hover:shadow-2xl transition-shadow"
                        >
                           <img
                              src="@/assets/img/productive.png"
                              alt="BlenderLink"
                              class="w-24 h-24 object-contain mb-4 rounded-lg shadow-md bg-white"
                           />
                           <h3
                              class="text-2xl font-semibold text-emerald-700 mb-2 flex items-center"
                           >
                              <i
                                 class="fas fa-blender mr-2 text-emerald-500"
                              ></i
                              >BlenderLink
                           </h3>
                           <p class="text-blueGray-700 text-center">
                              Real-time blender control and monitoring,
                              providing precise chemical and proppant delivery
                              for optimal frac performance.
                           </p>
                        </div>
                        <div
                           class="rounded-xl shadow-lg bg-gradient-to-br from-purple-50 to-purple-200 p-8 m-4 flex flex-col items-center hover:shadow-2xl transition-shadow"
                        >
                           <img
                              src="@/assets/img/servicesupport.png"
                              alt="PumpLink"
                              class="w-24 h-24 object-contain mb-4 rounded-lg shadow-md bg-white"
                           />
                           <h3
                              class="text-2xl font-semibold text-purple-700 mb-2 flex items-center"
                           >
                              <i
                                 class="fas fa-tachometer-alt mr-2 text-purple-500"
                              ></i
                              >PumpLink
                           </h3>
                           <p class="text-blueGray-700 text-center">
                              Advanced pump control and diagnostics, enabling
                              remote monitoring and automated safety features
                              for critical operations and maintenance tracking.
                           </p>
                        </div>
                        <div
                           class="rounded-xl shadow-lg bg-gradient-to-br from-pink-50 to-pink-200 p-8 m-4 flex flex-col items-center hover:shadow-2xl transition-shadow"
                        >
                           <img
                              src="@/assets/img/ami_wave_pic.jpg"
                              alt="HydrationLink"
                              class="w-24 h-24 object-contain mb-4 rounded-lg shadow-md bg-white"
                           />
                           <h3
                              class="text-2xl font-semibold text-pink-600 mb-2 flex items-center"
                           >
                              <i class="fas fa-flask mr-2 text-pink-400"></i
                              >HydrationLink
                           </h3>
                           <p class="text-blueGray-700 text-center">
                              Automated hydration unit management, ensuring
                              consistent gel quality and real-time data
                              integration with field operations.
                           </p>
                        </div>
                        <div
                           class="rounded-xl shadow-lg bg-gradient-to-br from-yellow-50 to-yellow-200 p-8 m-4 flex flex-col items-center hover:shadow-2xl transition-shadow md:col-span-2"
                        >
                           <img
                              src="@/assets/img/industrial-engineer-programming-machine-control.jpg"
                              alt="ChemLink"
                              class="w-24 h-24 object-contain mb-4 rounded-lg shadow-md bg-white"
                           />
                           <h3
                              class="text-2xl font-semibold text-yellow-700 mb-2 flex items-center"
                           >
                              <i class="fas fa-vials mr-2 text-yellow-500"></i
                              >ChemLink
                           </h3>
                           <p class="text-blueGray-700 text-center">
                              Comprehensive chemical management and tracking,
                              with automated dosing and full integration into
                              the DVCommand platform.
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </main>
      <footer-component />
   </div>
</template>
<script>
import NavbarComponent from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

export default {
   components: {
      NavbarComponent,
      FooterComponent,
   },
};
</script>
